export default __webpack_public_path__ + "static/media/195.285ed17e.jpg";